import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
	mutation DeleteBookmarkMutation($input: DeleteBookmarkInput!) {
		deleteBookmark(input: $input) {
			deletedBookmarkId
		}
	}
`;

function sharedUpdater(store, postId, deletedBookmarkId) {
	const postProxy = store.get(postId);
	const connection = ConnectionHandler.getConnection(
		postProxy,
		"Bookmark_simpleBookmark"
	);

	if (connection) {
		ConnectionHandler.deleteNode(connection, deletedBookmarkId);
	}
}

export default (postId, bookmarkId, callback) => {
	const variables = {
		input: {
			bookmarkId: bookmarkId
		}
	};

	commitMutation(environment, {
		mutation,
		updater(store) {
			const payload = store.getRootField("deleteBookmark");
			sharedUpdater(store, postId, payload.getValue("deletedBookmarkId"));
		},
		optimisticUpdater(store) {
			sharedUpdater(store, postId, bookmarkId);
		},
		variables,
		onCompleted: (response, errors) => {
			if (response.deleteBookmark != null) {
				callback();
			} else {
				// console.log("Unable to delete bookmark!");
			}
		},
		onError: err => console.error(err)
	});
};
